import React, {Fragment, useEffect} from 'react';
import Navbar from '../../components/Navbar'
import Hero from '../../components/hero'
import About from '../../components/about'
// import Service from '../../components/Service'
// import EventSection from '../../components/event'
// import Support from '../../components/Support'
import BlogSection from '../../components/BlogSection'
import FAQ from '../../components/FAQ'
import BookingForm from '../../components/BookingForm'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Testimonials from '../../components/Testimonials'
import abimg from '../../images/home/about.png'
// import evn1 from '../../images/event/img-1.jpg'
// import evn2 from '../../images/event/img-2.jpg'
import blog1 from '../../images/blog/blog1.webp'
import blog2 from '../../images/blog/blog2.webp'
import hero1 from '../../images/home/banner.png'
import Course from '../../components/Course'
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';


const HomePage =() => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1)); // Remove the #
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Add a small delay
            }
        }
    }, [location]);
    return(
        <Fragment>
            <Helmet>
                <title>Dar-ul-Quran Academy UK | Online Quran Classes for All Ages</title>
                <meta name="description" content="High-quality online Quran learning for UK Muslim families. Flexible schedules, certified tutors, and a supportive environment for children and adults." />
                <link rel="canonical" href="https://www.thedarulquran.com/" />
            </Helmet>
            <Navbar/>
            <Hero HeroStyleClass={'hero-style-2'} heroImg={hero1}/>
            <About aboutImg={abimg} isHomePage={true}/>
            <Course isHomePage={true} />
            <Testimonials/>
            <BlogSection blogImg1={blog1} blogImg2={blog2}/>
            <FAQ/>
            <BookingForm/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage;